module.exports = __webpack_public_path__ + "media/conmex/consultoria-a3c22753.png";